"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

/**
 * WidgetSubtitle component for rendering widget subtitles with appropriate heading levels
 * Heading level is determined based on whether the widget has a title for proper semantic hierarchy
 */
var WidgetSubtitle = function WidgetSubtitle(_ref) {
  var content = _ref.content,
      className = _ref.className,
      style = _ref.style,
      hasWidgetTitle = _ref.hasWidgetTitle;
  if (!content) return null;

  var getSubtitleHeadingTag = function getSubtitleHeadingTag() {
    // if title is set, subtitle should be h3 since title will be set to h2
    // if title is not set, subtitle should be h2 since it will be the first header tag in the widget
    if (hasWidgetTitle) {
      return 'h3';
    } // in case of no title set


    return 'h2';
  };

  var SubtitleHeadingTag = getSubtitleHeadingTag();
  return (0, _preact.h)(SubtitleHeadingTag, {
    style: style,
    className: "widget__subheading ".concat(className !== null && className !== void 0 ? className : '', " font-normal-weight")
  }, content);
};

var _default = WidgetSubtitle;
exports.default = _default;